import { Injectable } from '@angular/core';
import { Events } from '../events-monitor.types';
import { TableData } from '../../../../shared/types/api-response.types';
import { DurationPipe } from '../../../../shared/pipes/duration.pipe';
import { ExportRow } from '@portal/shared/types/export.types';
import { DeviceType } from '@ui/aos-lib';
import { devicesWithoutSerialNumber } from 'src/app/pages/equipment/devices/constants/devices.constants';

@Injectable({ providedIn: 'root' })
export class EventsMonitorModelService {
  readonly exportConfig = {
    fileName: 'Export-Events',
    mapData: (data: TableData<Events>): ExportRow[] => {
      return data.data.map(event => {
        return {
          commDeviceId: {
            title: 'CommDeviceID',
            value: event.commDeviceId ?? ''
          },
          serialNumber: {
            title: 'SerialNumber',
            value: devicesWithoutSerialNumber.includes(event.deviceType as DeviceType)
              ? ''
              : (event.serialNumber ?? 'Unknown Serial Number')
          },
          lastDetectedUtc: { title: 'LastDetected', value: event.lastDetectedUtc },
          endedAtUtc: { title: 'EndedAt', value: event.endedAtUtc },
          duration: {
            title: 'Duration',
            value: this.durationPipe.transform(event.lastDetectedUtcOriginal, event.endedAtUtcOriginal)
          },
          eventGroupName: { title: 'EventGroup', value: event.eventGroupName },
          eventName: { title: 'EventName', value: event.eventName },
          severity: { title: 'Severity', value: event.severity },
          status: { title: 'Status', value: event.status },
          value: { title: 'Value', value: event.value },
          unitOfMeasure: { title: 'Unit', value: event.unitOfMeasure },
          customerNumber: {
            title: 'CustomerNumber',
            value: event.servicePoints.reduce((acc, item, idx) => {
              const customerNumberAndCustomerSubnumber = item.fullCustomerNumber ?? '';
              return idx > 0 ? `${acc}\n${customerNumberAndCustomerSubnumber}` : customerNumberAndCustomerSubnumber;
            }, '')
          },
          accountNumber: {
            title: 'AccountNumber',
            value: event.servicePoints.reduce((acc, item, idx) => {
              const accountNumberAndAccountSubnumber = item.fullAccountNumber ?? '';
              return idx > 0 ? `${acc}\n${accountNumberAndAccountSubnumber}` : accountNumberAndAccountSubnumber;
            }, '')
          },
          billingCycle: {
            title: 'BillingCycle',
            value: (event.billingCycle ?? '')
              .split(',')
              .map(v => v.trim())
              .filter(Boolean)
              .join('\n')
          },
          serviceLocationId: {
            title: 'ServiceLocationId',
            value: event.servicePoints.reduce((acc, item, idx) => {
              const serviceLocationId = item.serviceLocationId ?? '';
              return idx > 0 ? `${acc}\n${serviceLocationId}` : serviceLocationId;
            }, '')
          },
          serviceLocationAddress: {
            title: 'ServiceLocationAddress',
            value: event.servicePoints.reduce((acc, item, idx) => {
              const serviceLocationAddress = item.serviceLocationAddress ?? '';
              return idx > 0 ? `${acc}\n${serviceLocationAddress}` : serviceLocationAddress;
            }, '')
          },
          deviceType: { title: 'DeviceType', value: event.deviceType },
          commodity: { title: 'Commodity', value: event.commodity },
          model: { title: 'Model', value: event.model },
          location: [
            { title: 'Latitude', value: event.geoMetaData?.latitude ?? '' },
            { title: 'Longitude', value: event.geoMetaData?.longitude ?? '' },
            { title: 'Comment', value: event.geoMetaData?.comments ?? '' }
          ]
        };
      });
    }
  };

  private durationPipe: DurationPipe;

  constructor() {
    this.durationPipe = new DurationPipe();
  }
}
